import React from "react";
import CountryForm from "../CountryForm";
import { useParams } from "react-router-dom";

const EditCountry = () => {
  const params = useParams();
  return <CountryForm mode="EDIT" param={params} />;
};

export default EditCountry;
